const od = {
  "भाजपा सदस्यता अभियान - 2024": "ବିଜେପି ସଦସ୍ୟତା ଅଭିଯାନ - 2024",
  "Select Language": "ଭାଷା ଚୟନ କରନ୍ତୁ |",
  Next: "ପରବର୍ତ୍ତୀ",
  "Enter your mobile number": "ଆପଣଙ୍କର ମୋବାଇଲ ନମ୍ବର ଦାଖଲ କରନ୍ତୁ",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "ମୁଁ ଚୁକ୍ତିନାମାକୁ ଗ୍ରହଣ କରୁଛି, ଏହା ସହ ମୁଁ ସ୍ବେଛାକୃତ ଭାବରେ ଭାଜପାର ସଦସ୍ୟ ହେବାକୁ ସହମତି ପ୍ରଦାନ କରୁଛି",
  "Get OTP": "OTP ପାଆନ୍ତୁ |",
  "Terms and Conditions": "ସର୍ତ୍ତାବଳୀ",
  "You must tick the box to continue, as it is mandatory.":
    "ଜାରୀ ରଖିବାକୁ ତୁମେ ବାକ୍ସରେ ଟିକ୍ କରିବା ଜରୁରୀ, ଏହା ବାଧ୍ୟତାମୂଳକ ଅଟେ",
  "Okay, Got it": "ଠିକ ଅଛି, ପ୍ରାପ୍ତ ହେଲା",
  "Get OTP": "OTP ପାଆନ୍ତୁ |",
  "Enter OTP": "OTP ପ୍ରବେଶ କରନ୍ତୁ |",
  "Resend OTP": "OTP ପଠାନ୍ତୁ |",
  Continue: "ଜାରୀ ରଖନ୍ତୁ",
  "Fill details": "ବିବରଣୀ ପୁରଣ କରନ୍ତୁ |",
  "Upload Photo": "ଫଟୋ ଅପଲୋଡ୍ କରନ୍ତୁ |",
  "Profile Photo": "ପ୍ରୋଫାଇଲ୍ ଫଟୋ",
  "Mobile number": "ମୋବାଇଲ୍ ନମ୍ବର |",
  "Mrs.": "ଶ୍ରୀମତୀ",
  "Mr.": "ଶ୍ରୀ",
  Ms: "ଶ୍ରୀମତୀ",
  "Full Name*": "ପୂର୍ଣ୍ଣ ନାମ *",
  "D.O.B": "D.O.B",
  Age: "ବୟସ",
  Gender: "ଲିଙ୍ଗ",
  Female: "ମହିଳା",
  Male: "ପୁରୁଷ",
  Other: "ଅନ୍ୟମାନେ |",
  "Email Id": "ଇମେଲ୍ ID",
  "Add address": "ଠିକଣା ଦାଖଲ କରନ୍ତୁ",
  "House/ Flat/ Floor No.": "ଘର /ଫ୍ଲାଟ / ପ୍ଲଟ ନମ୍ବର",
  "Current address PIN code": "ବର୍ତ୍ତମାନ ଠିକଣାର ପିନକୋଡ଼",
  "District*": "ଜିଲ୍ଲା *",
  State: "ରାଜ୍ୟ",
  "Assembly constituency (AC)": "ବିଧାନସଭା ନିର୍ବାଚନମଣ୍ଡଳୀ (ଏସି)",
  "Tell us about your location": "ନିଜ ସ୍ଥାନ(ଲୋକେସନ) ବିଷୟରେ ଜଣାନ୍ତୁ",
  "It will assist us in locating other members in your area.":
    "ଏହା ଆପଣଙ୍କ ଅଞ୍ଚଳରେ ଅନ୍ୟ ସଦସ୍ୟମାନଙ୍କୁ ଖୋଜିବାରେ ଆମକୁ ସାହାଯ୍ୟ କରିବ |",
  "Your address as fetched": "ଆପଣଙ୍କ ଠିକଣା ଯାହା ଫେଚ୍ ହୋଇଛି",
  "Referral code": "ରେଫରାଲ୍ କୋଡ୍ |",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "ମୁଁ ସୁନିଶ୍ଚିତ କରୁଛି ଯେ ଉପରୋକ୍ତ ସୂଚନା ସଠିକ ଏବଂ ଏଥିରେ କୌଣସି ଭୁଲ ନାହିଁ | ମୁଁ ଅବଗତ ଯେ ଉପରୋକ୍ତ ସମସ୍ତ ବିବରଣୀ ମାଧ୍ୟମରେ ଭବିଷ୍ୟତରେ ଯୋଗାଯୋଗ କରାଯିବ",
  Save: "ସଞ୍ଚୟ କରନ୍ତୁ |",
  Select: "ଚୟନ କରନ୍ତୁ |",
  Camera: "କ୍ୟାମେରା |",
  or: "କିମ୍ବା",
  Gallery: "ଗ୍ୟାଲେରୀ",
  "Support format : Jpeg, Png, Pdf": "ସମର୍ଥନ ଫର୍ମାଟ୍: Jpeg, Png, Pdf",
  Cancel: "ବାତିଲ୍ କରନ୍ତୁ |",
  "Select location": "ଅବସ୍ଥାନ ଚୟନ କରନ୍ତୁ |",
  "Provide location": "ଅବସ୍ଥାନ ପ୍ରଦାନ କରନ୍ତୁ |",
  "Search results": "ସନ୍ଧାନ ଫଳାଫଳ |",
  "Search for a building, street name or..": "ଘର, ରାସ୍ତା, ଗଳି ନାମର ସନ୍ଧାନ",
  "Your address as fetched": "ଆପଣଙ୍କ ଠିକଣା ଯାହା ଫେଚ୍ ହୋଇଛି",
  "Locate me": "ମୋତେ ଖୋଜ |",
  "Confirm location": "ସ୍ଥାନ(ଲୋକସନ) ନିଶ୍ଚିତ କରନ୍ତୁ",
  "Congratulations !": "ଅଭିନନ୍ଦନ!",
  "Your primary Id is -": "ତୁମର ପ୍ରାଥମିକ Id ହେଉଛି -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "ଆପଣଙ୍କର ତଥ୍ୟ ବୃଦ୍ଧି କରିବାକୁ, ଆପଣଙ୍କର ID କାର୍ଡକୁ ପ୍ରବେଶ କରିବାକୁ ଏବଂ ଅନ୍ୟମାନଙ୍କୁ ପ୍ରାଥମିକ ସଦସ୍ୟ ଭାବରେ ଯୋଗଦେବାକୁ Bjp.org/membership କୁ ଲଗ୍ ଇନ୍ କରନ୍ତୁ |",
  "ID CARD": "ID କାର୍ଡ |",
  "You can download your generated ID Card":
    "ଆପଣ ଆପଣଙ୍କର ତିଆରି ହୋଇଥିବା ID କାର୍ଡ ଡାଉନଲୋଡ଼ କରିପାରିବେ",
  Download: "ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
  "Go to dashboard": "ଡ୍ୟାସବୋର୍ଡକୁ ଯାଆନ୍ତୁ |",
  "View your profile": "ଆପଣଙ୍କର ପ୍ରୋଫାଇଲ୍ ଦେଖନ୍ତୁ |",
  "Refer and add member": "ରେଫର୍ କରି ସଦସ୍ୟଙ୍କୁ ଯୋଡ଼ନ୍ତୁ",
  Share: "ଅଂଶୀଦାର କରନ୍ତୁ |",
  "To update your additional details and refer more member, please click here.":
    "ଆପଣଙ୍କର ଅତିରିକ୍ତ ବିବରଣୀ ଅପଡେଟ୍ କରିବାକୁ ଏବଂ ଅଧିକ ସଦସ୍ୟଙ୍କୁ ରେଫର୍ କରିବାକୁ, ଦୟାକରି ଏଠାରେ କ୍ଲିକ୍ କରନ୍ତୁ |",
  "Bharatiya Janata Party": "ଭାରତୀୟ ଜନତା ପାର୍ଟି",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6A, DEENDAYAL UPADHYAYA MARG, ନୂଆଦିଲ୍ଲୀ - 110002",
  Name: "ନାମ",
  "Membership Number": "ସଦସ୍ୟତା ସଂଖ୍ୟା",
  "QR Code": "QR କୋଡ୍",
  "Please select a year between 1930 and 2006.":
    "ଦୟାକରି 1930 ରୁ 2006 ମଧ୍ୟରେ ଏକ ବର୍ଷ ଚୟନ କରନ୍ତୁ |",
  "Please enter a valid email address.":
    "ଦୟାକରି ଏକ ବୈଧ ଇମେଲ୍ ଠିକଣା ପ୍ରବେଶ କରନ୍ତୁ |",
  "Please enter 6-digit PIN code.":
    "ଦୟାକରି 6-ଅଙ୍କ ବିଶିଷ୍ଟ PIN କୋଡ୍ ପ୍ରବେଶ କରନ୍ତୁ |",
  "10-digit mobile number.": "10-ଅଙ୍କ ବିଶିଷ୍ଟ ମୋବାଇଲ୍ ନମ୍ବର |",
  "Please enter a 10-digit mobile number.":
    "ଦୟାକରି ଏକ 10 ଅଙ୍କ ବିଶିଷ୍ଟ ମୋବାଇଲ୍ ନମ୍ବର ପ୍ରବେଶ କରନ୍ତୁ |",
  "Please enter your name.": "ଦୟାକରି ଆପଣଙ୍କର ନାମ ପ୍ରବେଶ କରନ୍ତୁ |",
  "I pledge and willing to receive regular updates from BJP":
    "ମୁଁ ବିଜେପିରୁ ନିୟମିତ ଖବର ଗ୍ରହଣ କରିବାକୁ ପ୍ରତିଶ୍ରୁତି ଦେଉଛି ଏବଂ ଇଚ୍ଛୁକ |",
  "Get Verification Code": "ସତ୍ୟାପନ କୋଡ୍ ପାଇଁ",
  "Enter Verification Code": "ସତ୍ୟାପନ କୋଡ୍ ଭରନ୍ତୁ",
  "Resend Verification Code": "ସତ୍ୟାପନ କୋଡ୍ ପୁନରାବୃତ୍ତ କରନ୍ତୁ",
  "Provide Details": "ବିବରଣୀ ଦିଅନ୍ତୁ",
  Upload: "ଅପଲୋଡ୍ କରନ୍ତୁ",
  Ok: "ଠିକ୍",
  Calendar: "କ୍ୟାଲେଣ୍ଡର୍",
  "Full Address": "ସମ୍ପୂର୍ଣ୍ଣ ଠିକଣା",
  "Privacy policy": "ଗୋପନୀୟତା ନୀତି",
  Disclaimer: "ପ୍ରତ୍ୟାଖ୍ୟାନ |",
  "Contact us": "ଆମ ସହ ସଂପର୍କ କରନ୍ତୁ",
  Save: "ସଂରକ୍ଷଣ କରନ୍ତୁ",
  "Your primary member ID": "ତୁମର ପ୍ରାଥମିକ ସଦସ୍ୟ ID",
  "Membership Card": "ସଦସ୍ୟତା କାର୍ଡ",
  "Your Unique Referral code": "ତୁମର ଅନନ୍ୟ ରେଫରାଲ୍ କୋଡ୍ |",
  "Invite and add member": "ଆମନ୍ତ୍ରଣ ଦିଅନ୍ତୁ ଏବଂ ସଦସ୍ୟ ଯୋଡନ୍ତୁ",
  Share: "ସେୟାର୍ କରନ୍ତୁ",
  "Click below to add more details, donate and add other members to BJP":
    "ତଥ୍ୟ ଯୋଡିବା, ଅଧିକ ଯୋଡିବା  ଏବଂ ଅନ୍ୟ ସଦସ୍ୟମାନେ BJP କୁ ଯୋଗ କରିବାକୁ ନିମ୍ନରେ କ୍ଲିକ୍ କରନ୍ତୁ",
  "Update your details": "ଆପଣଙ୍କର ବିବରଣୀ ଅପଡେଟ୍ କରନ୍ତୁ",
  "Add Referral Details": "ରେଫରାଲ୍ ବିବରଣୀ ଯୋଡନ୍ତୁ |",
  "Referred by (name)": "(ନାମ) ଦ୍ୱାରା ସୂଚିତ |",
  "Referred by (mobile number)": "(ମୋବାଇଲ୍ ନମ୍ବର) ଦ୍ୱାରା ସୂଚିତ |",
  Capture: "ଫଟୋ ଉo|ଓ ",
  "Close Camera": "କ୍ୟାମେରା ବନ୍ଦ କରନ୍ତୁ |",
  Uploading: "ଅପଲୋଡ୍ କରୁଛି |",
  "Your Unique Referral Link": "ତୁମର ଅନ୍ୟ ରେଫରାଲ୍ ଲିଙ୍କ୍ |",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "ଆପଣ ଆଜି ପାଇଁ ସର୍ବାଧିକ OTP ପ୍ରୟାସରେ ପହଞ୍ଚିସାରିଛନ୍ତି | ଦୟାକରି ଆସନ୍ତାକାଲି ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ |",
  Miss: "ଶ୍ରୀମତୀ",
  "Full Name": "ପୂର୍ଣ୍ଣ ନାମ",
  "OTP limit reached for today. Please try again tomorrow":
    "ଆଜି ପାଇଁ OTP ସୀମା ପହଞ୍ଚିଛି | ଦୟାକରି ଆସନ୍ତାକାଲି ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ |",
  ": is not a Primary Member, Only Primary Members can refer":
    ": ଏକ ପ୍ରାଥମିକ ସଦସ୍ୟ ନୁହଁନ୍ତି, କେବଳ ପ୍ରାଥମିକ ସଦସ୍ୟମାନେ ରେଫର୍ କରିପାରିବେ |",
  "Please enter valid fullname": "ସଠିକ୍ ପୂର୍ଣ୍ଣ ନାମ ପ୍ରବେଶ କରନ୍ତୁ  |",
  Upload: "ଅପଲୋଡ୍ କରନ୍ତୁ",
};

export default od;
